
import Passenger from "@/components/Passenger/models/Passenger";
import { Vue, Prop, Component } from "vue-property-decorator";
import DateTimePicker from "@/components/DatetimePicker.vue";
import restService from "@/services/restService";
import Trip from "@/components/Passenger/models/Trip";
import { Group } from "@/components/Passenger/models/Group";
import GroupPicker from "@/components/Passenger/components/GroupPicker.vue";
import PassengerList from "@/components/Passenger/components/PassengerList.vue";

@Component({
  components: {
    DateTimePicker,
    GroupPicker,
    PassengerList
  },
})
export default class MassCancellationOfTripsView extends Vue {
  cancelreasonrules: any[] = [(val) => this.cancelReasonRequired(val)];
  searchByName: string | null = null;
  ids: number[] = [];
  loading: boolean = false;
  dialogLoading: boolean = false;
  showCancelDialog: boolean = false;
  cancelReason: string = "";
  percentage = 0;
  cancelreasonvalid = false;
  allTrips: Trip[] = [];
  tripsStartDate: string = new Date().toISOString().substr(0, 10);
  today: string = new Date().toISOString().substr(0, 10);
  tripsEndDate: string = new Date().toISOString().substr(0, 10);
  searchDone: boolean = false;
  groupNamesToFilterIn: string[] = [];
  pagination: any = {
    sortBy: "name",
    descending: true,
    rowsPerPage: 10,
  };

  // get startLabel() {
  //   return this.$t('timetable.starts', 'Starts')
  // }

  get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
  }

  onPickedPassengersChange(pickedPassengers: Passenger[]){
    this.ids = pickedPassengers.map(p => p.id);
    if (this.searchDone){
      this.allTrips = this.allTrips.filter(t => this.ids.includes(t.passengerId));
      if (this.allTrips.length === 0){
        this.clearSearch();
      }
    }
  }

  get activeTripsCountHeader(){
    return {
        i18n: "passenger.prop.activeTrips.label",
        text: "Active trips",
        value: "activeTripsCount",
        sortable: true,
        align: "right",
      }
  }

  get paginatedPassengers(): Passenger[] {
    let passengers = (this.$store.state.passenger.paginatedPassengers as Passenger[])
    return passengers;
  }

  get activeTrips() {
    return this.allTrips.filter((t) => !t.cancelledAt).length;
  }

  cancelReasonRequired(val: string) {
    return !!val || Vue.i18n.translate("validation.rules.required", "Required");
  }

  async fetchTrips() {
    this.loading = true;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.ids.length; i++) {
      // tslint:disable-next-line:max-line-length
      const result = await restService.passengers.getPassengerTrips(
        this.ids[i],
        this.tripsStartDate,
        this.tripsEndDate,
        this.routeDestinationId
      );
      const trips = result.map((t) => Trip.WithPassengerId(t, this.ids[i]));
      this.percentage = Math.round((i / this.ids.length) * 100);

      this.allTrips = this.allTrips.concat(trips);
    }
    this.loading = false;
    this.percentage = 0;
    this.searchDone = true;
  }

  startDateUpdated(value) {
    this.tripsStartDate = value;
    if (value > this.tripsEndDate) {
      this.tripsEndDate = value;
    }
    const maxEnd = new Date(value);
    maxEnd.setMonth(maxEnd.getMonth() + 1);
    if (new Date(this.tripsEndDate).getTime() > maxEnd.getTime()) {
      this.tripsEndDate = maxEnd.toISOString().substr(0, 10);
    }
  }

  endDateUpdated(value) {
    this.tripsEndDate = value;
    if (value < this.tripsStartDate) {
      this.tripsStartDate = value;
    }
    const minStart = new Date(value);
    minStart.setMonth(minStart.getMonth() - 1);
    if (new Date(this.tripsStartDate).getTime() < minStart.getTime()) {
      this.tripsStartDate = minStart.toISOString().substr(0, 10);
    }
  }

  activeTripsForPassenger(id: number) {
    return this.allTrips
      .filter((t) => t.passengerId === id)
      .filter((t) => !t.cancelledAt).length;
  }

  cancelledTripsForPassenger(id: number) {
    return this.allTrips
      .filter((t) => t.passengerId === id)
      .filter((t) => t.cancelledAt).length;
  }

  async onCancelTripsClick() {
    this.dialogLoading = true;
    const toBeCancelled = this.allTrips.filter((t) => !t.cancelledAt);

    const groups = toBeCancelled.reduce((r, a) => {
      r[a.passengerId] = [...(r[a.passengerId] || []), a];
      return r;
    }, {});

    let i = 0;
    const groupsSize = Object.keys(groups).length;
    for (const key in groups) {
      if (Object.prototype.hasOwnProperty.call(groups, key)) {
        const cancellation = {
          reason: this.cancelReason,
          trips: groups[key],
        };
        const result = await restService.passengers.cancelPassengerTrips(
          parseInt(key, 10),
          cancellation
        );
        this.updateCanceledTripsToAllTrips(result, parseInt(key, 10));        
        i++;
        this.percentage = Math.round((i / groupsSize) * 100);
      }
    }
    this.dialogLoading = false;
    this.showCancelDialog = false;
    this.percentage = 0;
  }

  updateCanceledTripsToAllTrips(result: any, passengerId: number) {
    result.forEach(t => {
      const updatedTrip = Trip.WithPassengerId(t, passengerId);
      const target = this.allTrips.find(trip => trip.id === updatedTrip.id && trip.date === updatedTrip.date);
      if (target) {
        const index = this.allTrips.indexOf(target);
        this.allTrips.splice(index, 1, updatedTrip);
      } else {
        console.log(updatedTrip)
      }

    });

  }

  clearSearch() {
    this.paginatedPassengers.forEach((p) => (p.picked = false));
    this.ids = [];
    this.allTrips = [];
    this.searchDone = false;
  }

}
